<!-- filepath: /workspaces/books/src/components/PrivacyPolicyModal.vue -->
<template>
  <div class="privacy-policy-overlay" @click.self="$emit('close')">
    <div class="privacy-policy-container">
      <div class="privacy-policy-header">
        <h2>プライバシーポリシー</h2>
        <button class="close-button" @click="$emit('close')">×</button>
      </div>
      
      <div class="privacy-policy-body">
        <p>txt365.org（以下「当団体」といいます）は、個人情報の重要性を認識し、個人情報保護に関する法令および関連ガイドラインを遵守して、適切に個人情報を取り扱います。本ポリシーは、当団体が取得した個人情報等の取り扱い方針を示すものです。</p>

        <h3>第1条（定義）</h3>
        <ul>
          <li><strong>個人情報</strong>：特定の個人を識別できる情報を指します（氏名、住所、電話番号、メールアドレスなど）。</li>
          <li><strong>個人情報等</strong>：個人情報および個人情報と関連付けられ得るその他の情報を含みます。</li>
        </ul>

        <h3>第2条（取得する情報）</h3>
        <ol>
          <li>当団体は、利用者が入力または送信した情報、問い合わせフォームや電子メール等で任意に提供された情報などを取得する場合があります。</li>
          <li>当団体が提供するウェブサイト・アプリ等（以下「ウェブサイト等」）の利用状況を把握し、利便性向上やサービス改善のために、Cookieやアクセスログ解析等の手段を通じて情報を取得する場合があります。</li>
        </ol>

        <h3>第3条（利用目的）</h3>
        <p>当団体は、取得した個人情報等を以下の目的で利用します。</p>
        <ol>
          <li>問い合わせへの対応、および必要に応じた連絡</li>
          <li>ウェブサイト等の機能改善や品質向上のための分析</li>
          <li>利用者の利便性向上に資するカスタマイズやコンテンツ配信</li>
          <li>法令で認められる場合、または利用者の同意を得た目的の範囲内での利用</li>
        </ol>

        <h3>第4条（第三者提供）</h3>
        <p>当団体は、取得した個人情報等を、以下に該当する場合を除き、第三者に提供することはありません。</p>
        <ol>
          <li>法令に基づく場合</li>
          <li>利用者本人の同意がある場合</li>
          <li>当団体が業務を行ううえで必要な範囲内で、業務委託先等に開示する場合（この場合、情報の適切な取扱いを契約等で義務付けます）</li>
        </ol>

        <h3>第5条（安全管理措置）</h3>
        <ol start="4">
          <li>当団体は、個人情報等の漏えい、改ざん、紛失、不正アクセスなどを防ぐため、組織的・人的・物理的・技術的な安全管理措置を講じます。</li>
          <li>当団体のウェブサイト等を通じて個人情報等を送信する場合には、通信の暗号化やアクセス権限の制限等、適切な保護策を講じるよう努めます。</li>
        </ol>

        <h3>第6条（保管期間）</h3>
        <p>当団体は、個人情報等を利用目的に必要な期間に限り保管し、当該期間終了後または利用目的が達成された後は、適切な方法で速やかに廃棄または匿名化するよう努めます。</p>

        <h3>第7条（利用者の権利）</h3>
        <ol start="6">
          <li>利用者は、当団体が保有する自身の個人情報等について、開示・訂正・削除等を求めることができます。</li>
          <li>具体的な請求の手続きは、当団体が定める方法に従い行ってください。</li>
          <li>当団体は、合理的な範囲で速やかに対応しますが、法令により開示等が制限される場合があります。</li>
        </ol>

        <h3>第8条（未成年者の個人情報）</h3>
        <p>未成年の利用者が個人情報を提供する場合は、必ず保護者の同意を得たうえで行うものとします。当団体が未成年者による個人情報の提供を認識した場合、必要に応じて保護者の同意の確認を行うことがあります。</p>

        <h3>第9条（プライバシーポリシーの変更）</h3>
        <ol start="9">
          <li>当団体は、必要に応じて本ポリシーを変更することができます。</li>
          <li>変更後のポリシーは、当団体が適切と判断する方法で告知した時点から効力を生じます。</li>
          <li>変更後もウェブサイト等を利用する場合、変更内容に同意したものとみなします。</li>
        </ol>

        <h3>第10条（お問い合わせ窓口）</h3>
        <p>本ポリシーに関するお問い合わせ、または個人情報等の開示・訂正・削除等のご依頼については、当団体が指定する問い合わせ先（メールアドレスや問い合わせフォーム等）までご連絡ください。</p>
      </div>
      
      <div class="privacy-policy-buttons">
        <button class="close-button-bottom" @click="$emit('close')">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyModal'
}
</script>

<style scoped>
.privacy-policy-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}

.privacy-policy-container {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.privacy-policy-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.privacy-policy-header h2 {
  margin: 0;
  font-size: 1.3rem;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
}

.close-button:hover {
  color: #333;
}

.privacy-policy-body {
  padding: 20px;
  overflow-y: auto;
  flex-grow: 1;
  line-height: 1.6;
}

.privacy-policy-body h3 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: #333;
}

.privacy-policy-body p {
  margin-bottom: 1em;
}

.privacy-policy-body ol, .privacy-policy-body ul {
  padding-left: 1.5em;
  margin-bottom: 1em;
}

.privacy-policy-body li {
  margin-bottom: 0.5em;
}

.privacy-policy-buttons {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  text-align: center;
}

.close-button-bottom {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 8px 25px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.close-button-bottom:hover {
  background-color: #d9b6ab;
}
</style>